import React, { useState, useEffect, useRef } from 'react';
import { Dialog, Card } from '@mui/material';
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import { cleanObject, copyToClipboard } from '../../helpers/helperFunctions';
import NewButton from '../Buttons/NewButton';

const StolenModeModal = ({show, onClose, info, type, device, onSave, download, deleteImg }) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    const [confirmation, setConfirmation] = useState(false)
    const [additionalInfo, setAdditionalInfo] = useState("")

    const [imgFile, setImgFile] = useState()

    const [currentImg, setCurrentImg] = useState()
    const [copySuccess, setCopySuccess] = useState(false)
    const inputFile = useRef(null);


    const handleClose = () => {
        onClose()
    }

    const handleSave = (type) => {
           let data = {}
        let reset = false
        switch(type){
            case "additional":
                data.deviceid = device?.id
                data.action = "configure"
                data.description = additionalInfo
                data.img = imgFile
            break;
            case "activate":
                data.deviceid = device?.id
                data.action = "activate"
            break;
            default: data = {}
        }
        const cleaned = cleanObject(data)
        onSave(cleaned, reset)
    }


    useEffect(() => {
        setAdditionalInfo(info?.description ?? "")
        setCurrentImg(info?.image_url)
    }, [info])

    const copyLink = (url) => {
        copyToClipboard(url)
        .then((result) => {
            setCopySuccess(true)
            setTimeout(() => {
                setCopySuccess(false)
            }, 1000);
		})
		.catch((error) => {
			console.error("Copy failed:", error); // trigger failure action
		});
    }

    const uploadHandler = () => {
        inputFile.current.click();
    }

    const handleUploadedImg = async (imgfile) => {
        if (imgfile) {
            // Create a URL for the file
            const imageUrl = URL.createObjectURL(imgfile);
            // Update your component's state to reflect the new image
            setCurrentImg(imageUrl);
            setImgFile(imgfile)
        }
    }

    const clearImg = () => {
        if(!currentImg) return
        setCurrentImg()
        setImgFile()
        deleteImg()
    }

    const disabledContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="">{t("settings.stolen_mode")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("settings.stolen_mode_tos")}</p>
                <div className="d-flex align-items-center">
                    <div className={`${confirmation ? "bg-checked" : "bg-grey"} size_25 rounded8 d-flex justify-content-center align-items-center p-1`} onClick={() => setConfirmation(!confirmation)}>
                        {confirmation && <img className="white-icon size_15" src={icons.check} alt={""} />}
                    </div>
                    <p className="grey-blue ms-2">{t("settings.tos_confirmation")}</p>
                </div>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => handleClose()} className="bg-grey rounded24 w-100 dark-grey me-2 p-3 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave("activate")} disabled={!confirmation} className={`bg-gradient rounded24 w-100 white-white ms-2 p-3 body bold ${!confirmation ? "disabled" : ""}`}>{t("settings.enable")}</NewButton>
                </div>
            </div>
        )
    }



    const additionalContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="">{t("settings.additional")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("settings.additional_info_desc")}</p>
                <div className="d-flex justify-content-around">
                    <div className="userimage">
                        <img src={currentImg ? currentImg : images.placeholder_img} alt="" className="w-100 object-fit-cover"/>
                    </div>
                    <div className="d-flex flex-column justify-content-around">
                        <NewButton onClick={uploadHandler} icon={icons.plus_circle} iconClass={"grey-blue-icon size_15"} className="bg-grey grey-blue rounded24 p bold">
                            {currentImg ? t("settings.edit_picture") : t("settings.add_picture")}
                        </NewButton>
                        <input
                            type="file"
                            id="file"
                            accept=".png, .jpg, .jpeg"
                            className="cursor-pointer invisible"
                            onChange={(e) => handleUploadedImg(e.target.files[0])}
                            ref={inputFile}
                            style={{ display: "none" }}
                        />
                        <NewButton onClick={() => clearImg()} icon={icons.trashcan} iconClass={"red-icon size_15"} className="bg-grey red rounded24 p bold">
                            {t("settings.remove_picture")}
                        </NewButton>
                    </div>
                </div>
                <textarea 
                    rows={3} 
                    placeholder={t("settings.additional_info_placeholder")} 
                    defaultValue={additionalInfo} 
                    onChange={(event) => setAdditionalInfo(event.target.value)} 
                    className="mt-3 form-control text-area-boy bg-light-grey rounded24"  />    
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => handleClose()} className="bg-grey rounded24 w-100 dark-grey me-2 p-3 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave("additional")} className={`bg-gradient rounded24 w-100 white-white ms-2 p-3 body bold`}>{t("settings.save")}</NewButton>
                </div>
            </div>
        )
    }

    const linkContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="">{t("settings.stolen_mode_link")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("settings.stolen_mode_link_desc")}</p>
                <form>
                    <div className="form-group d-flex align-items-center position-relative rounded24 bg-light-grey">
                        <input
                            type={"text"}
                            className="form-control rounded24 p-3 bg-light-grey grey-blue pe-5"
                            id="text"
                            value={info?.url ?? ""}
                            placeholder=""
                            readOnly={true}
                        />
                        <img src={copySuccess ? icons.radio_checked : icons.copy} onClick={() => copyLink(info?.url)} className={`${copySuccess ? "": "inp-link-icon"} position-absolute size_15 ms-2 cursor-pointer end-0 me-2`} alt="" />
                    </div>
                </form>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => handleClose()} className="bg-grey rounded24 w-100 dark-grey p-3 body bold">{t("settings.close")}</NewButton>
                </div>
            </div>
        )
    }

    const typeRender = () => {
        switch (type){
            case "activate":
                return disabledContent()
            case "additional":
                return additionalContent()
            case "link":
                return linkContent()
            default: return null
        }
    }


return(
    <>
    <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
        <Card className="settings-dialog d-flex flex-column scrollable-y">
            <div className="w-100 h-100 grey-blue">
                {typeRender()}
            </div>
        </Card>
    </Dialog>
    </>
)
}

export default StolenModeModal;